import { render } from "./DefaultCheck.vue?vue&type=template&id=48817698&scoped=true"
import script from "./DefaultCheck.vue?vue&type=script&lang=js"
export * from "./DefaultCheck.vue?vue&type=script&lang=js"

import "./DefaultCheck.vue?vue&type=style&index=0&id=48817698&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48817698"

export default script